module.exports = __webpack_public_path__ + "img/coupon-pass.4e236c95.png";